import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close(event) {
    const button = event.currentTarget
    const customCallback = button.dataset.onClose

    // Execute custom callback if provided
    if (customCallback) {
      try {
        eval(customCallback)
      } catch (e) {
        console.error("Error executing onClose callback:", e)
      }
    }

    // Remove the tag element with animation
    this.element.style.transition = "opacity 150ms ease-out, transform 150ms ease-out"
    this.element.style.opacity = "0"
    this.element.style.transform = "scale(0.95)"

    setTimeout(() => {
      this.element.remove()
    }, 150)
  }
}
